export interface User {
  firebase_uid: string;
  email: string;
  full_name: string;
  first_name?: string;
  last_name?: string;
  created_at: string;
  category_id?: string | null;
  billing_address?: Record<string, any> | null;
  currency_preference?: string;
  username?: string | null;
  status?: string;
  email_verified?: boolean;
  is_active?: boolean;
  users_metadata?: Record<string, any> | null;
  /** First-class RBAC role. Values: 'user' | 'admin'. Default: 'user'. */
  role?: 'user' | 'admin' | string | null;
}

export interface UserProfile {
  id: string;
  user_id: string;
  phone?: string | null;
  address?: string | null;
  city?: string | null;
  country?: string | null;
  timezone?: string | null;
  language?: string | null;
  profile_metadata?: Record<string, any> | null;
  created_at: string;
  updated_at: string;
}

/**
 * Helper function to map backend user response to User type
 */
export function mapBackendUserToUser(backendUser: {
  firebase_uid?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  created_at?: string;
  category_id?: string | null;
  billing_address?: Record<string, any> | null;
  currency_preference?: string;
  username?: string | null;
  status?: string;
  email_verified?: boolean;
  is_active?: boolean;
  users_metadata?: Record<string, any> | null;
  role?: string | null;
}): User | null {
  if (!backendUser.firebase_uid || !backendUser.email) {
    return null;
  }

  const fullName = backendUser.first_name && backendUser.last_name
    ? `${backendUser.first_name} ${backendUser.last_name}`
    : backendUser.first_name || backendUser.last_name || '';

  return {
    firebase_uid: backendUser.firebase_uid,
    email: backendUser.email,
    full_name: fullName,
    first_name: backendUser.first_name,
    last_name: backendUser.last_name,
    created_at: backendUser.created_at || new Date().toISOString(),
    category_id: backendUser.category_id,
    billing_address: backendUser.billing_address,
    currency_preference: backendUser.currency_preference,
    username: backendUser.username,
    status: backendUser.status,
    email_verified: backendUser.email_verified,
    is_active: backendUser.is_active,
    users_metadata: backendUser.users_metadata,
    role: backendUser.role ?? 'user',
  };
}

